import {
  DELETE_POS_CATALOG,
  DELETE_POS_CATALOG_SUCCESS,
  DELETE_POS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const deletePosCatalogRed = (
  state: any = false,
  actions: any
) => {
  switch (actions.type) {
    case DELETE_POS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case DELETE_POS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case DELETE_POS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
